import CustomContainer from './component'

export default CustomContainer
